/*
@Usage: 
Just returns Checked or unchecked styles
needed, no touchable capabilities yet,
just a simple conditional renderer
*/

import React from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

import colors from 'constants/colors';
import Icon from 'shared/modules/common/components/atoms/Icon';
import generateID from 'shared/modules/common/utils/generate-id';

export default function SimpleRadio(props: {
  checked: boolean;
  style?: StyleProp<ViewStyle>;
}) {
  const { checked, style } = props;

  return (
    <View style={[styles.mainContainer, style]}>
      {checked ? (
        <Icon
          {...generateID('simple-checked')}
          name="checkbox-circle-checked-pink"
          size="32"
          style={styles.checked}
        />
      ) : (
        // fake border added to keep consistency in height of component
        <View style={styles.fakeBorder}>
          <View {...generateID('simple-unchecked')} style={styles.unchecked} />
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    height: 25,
  },
  checked: {
    width: 32,
    height: 32,
  },
  fakeBorder: {
    width: 32,
    height: 32,
    borderRadius: 15,
    borderWidth: 1,
    borderColor: colors.white,
    alignItems: 'center',
    justifyContent: 'center',
  },
  unchecked: {
    width: 24,
    height: 24,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#8A8A8A',
  },
});
